export const PRIMARY_COLOR_STORAGE_KEY = 'platform-primary-color'
export const COLOR_SCHEME_STORAGE_KEY = 'platform-color-scheme'
export const DEFAULT_PRIMARY_COLOR = 'energy-green'
export const OLD_DEFAULT_PRIMARY_COLOR = 'shalion-green'
export const DEFAULT_COLOR_SCHEME = 'dark'
